import { render } from "./page10.vue?vue&type=template&id=bc2d64c0&scoped=true"
import script from "./page10.vue?vue&type=script&lang=js"
export * from "./page10.vue?vue&type=script&lang=js"

import "./page10.vue?vue&type=style&index=0&id=bc2d64c0&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2d64c0"]])

export default __exports__